import { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { unallocatedItems } from '../../../lib/packingListAllocation';
import ItemsDataTable from './ItemsDataTable';
import ContainerAllocPanel from './ContainerAllocPanel';
import UnallocatedAlert from './UnallocatedAlert';

/** 확정된 라인 테이블과 컨테이너 배분 패널(서버 workspace 기준). 문서 카드를 고르면 그 문서 라인만 테이블에 보이고, 배분은 HBL 전체 기준이다. */
export default function ItemsSection({ hbl, items, allocations, allocationVersion, documentHints, filterDocId, onSaveAllocations }) {
    const visibleItems = useMemo(() => (filterDocId ? items.filter((i) => i.packing_list_id === filterDocId) : items), [items, filterDocId]);
    const [filterUnallocated, setFilterUnallocated] = useState(false);
    const unallocatedCount = useMemo(() => (hbl.containers.length > 1 ? unallocatedItems(items, allocations).length : 0), [items, allocations, hbl.containers.length]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#01354d' }}>
                    Items ({visibleItems.length}{filterDocId && visibleItems.length !== items.length ? ` of ${items.length}` : ''})
                </Typography>
                {hbl.containers.length > 1 && <UnallocatedAlert count={unallocatedCount} active={filterUnallocated} onToggle={() => setFilterUnallocated((v) => !v)} />}
            </Box>
            {visibleItems.length === 0 ? (
                <Typography sx={{ fontSize: 11, color: '#6b7a82' }}>No confirmed PL lines yet. Upload a PL and confirm it to see lines here.</Typography>
            ) : (
                <ItemsDataTable items={visibleItems} allocations={allocations} filterUnallocated={filterUnallocated} />
            )}
            <Box>
                <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#01354d', mb: 0.5 }}>Container Allocation</Typography>
                <ContainerAllocPanel
                    hbl={hbl}
                    items={items}
                    allocations={allocations}
                    allocationVersion={allocationVersion}
                    documentHints={documentHints}
                    onSave={onSaveAllocations}
                />
            </Box>
        </Box>
    );
}
